export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden border-b border-zinc-800"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70"
        style={{
          backgroundImage: `url(${image})`,
        }}
        aria-hidden
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/70 to-zinc-950/20"
        aria-hidden
      />
      <div
        className="absolute inset-0 bg-gradient-to-t from-zinc-950/90 via-zinc-950/30 to-transparent"
        aria-hidden
      />
      <div className="container-max relative">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1
          className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl uppercase tracking-wider text-zinc-50 mt-5 max-w-5xl drop-shadow-[0_4px_24px_rgba(0,0,0,0.6)]"
          data-testid="page-hero-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-zinc-200 max-w-2xl mt-6 text-lg leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.6)]">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
